import { isFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';
import { KNOWN_COPILOT_ADDINS, KNOWN_DEBUG_ADDINS } from '../constants/copilotAddinIds';

export function getSalesAddins(mailboxInfo: MailboxInfo) {
    return KNOWN_COPILOT_ADDINS.concat(
        isFeatureEnabled('mon-copilot-ext-debug-addins', mailboxInfo) ? KNOWN_DEBUG_ADDINS : []
    );
}
